import Image from 'next/image'

import Flex from '@totallymoney/ui/components/Flex'

import backgroundBlobIndigo30 from '@images/background-smooth-blob-indigo30.png'

const UnscoredCategoryPageBackgroundTextureCardTypesSection = () => (
    <Flex
        justifyContent="center"
        alignItems={['flex-start', 'center']}
        zIndex={0}
        mt="space130"
        aria-hidden="true"
    >
        <Image
            src={backgroundBlobIndigo30}
            alt=""
            placeholder="empty"
            sizes="100vw"
            quality={60}
            priority={false}
        />
    </Flex>
)

export default UnscoredCategoryPageBackgroundTextureCardTypesSection
